// import React from "react";
// import { useState } from "react";
// import { useEffect } from "react";
// import { useRef } from "react";
// import { useHistory, useLocation } from "react-router-dom";
// import { FaRegUserCircle, FaTimes, FaSearch } from "react-icons/fa";
// import { CiSearch } from "react-icons/ci";
// import { FiPhoneCall } from "react-icons/fi";
// import CryptoJS from "crypto-js";
// import WestIcon from "@mui/icons-material/West";

// import CircularProgress from "@mui/material/CircularProgress";
// import Tabs from "@mui/material/Tabs";
// import Tab from "@mui/material/Tab";

// import useHttp from "../../Hooks/use-http";
// import DriverBooking from "./PrivateDriverBooking";
// import Loading from "../../Loading/Loading";
// import Message from "../../Modal/Message";
// import "./LiveTracking.css";
// import startPoint from "../../Assets/dropIcon.png";
// import endPoint from "../../Assets/pickIcon.png";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import { IconButton, TextField, Tooltip } from "@mui/material";
// import { LiveLocationCallDuration } from "../DurationGap/DurationCall";
// import { FileCopy as FileCopyIcon } from "@mui/icons-material";
// // import { carIcon } from "../../Constant";
// import carIcon from "../../Assets/live_car.png"; // Ensure this is a car icon image

// let prev_driverEmail = "";
// let flightPlanCoordinates = [];
// let emailFlag = true;
// let driverFlag = true;
// let trip_interval = "";
// let pathInterval = "";
// let myFlag = 1;
// let map;
// let prev_driverId = "";
// let flightPath1;
// let flightPath2;
// let marker = null;
// let startPointMarker;
// let endPointMarker;
// var numDeltas = 100;
// var delay = 20; //milliseconds
// var i = 0;
// var deltaLat;
// var deltaLng;

// let drawLineFlag = false;
// let journeyStart = 0;
// let onTripDriverName = "";
// let riderDetails = [];
// let onlineDriversMarker = [];
// const LiveTracking = (props) => {
//   const [bookedDriver, setBookedDriver] = useState(null);
//   const [tripIdOfOnTrip, setTripIdOfOnTrip] = useState("");
//   const [onTripDriverEmail, setOnTripDriverEmail] = useState(null);
//   const [tripRequestStatus, setTripRequestStatus] = useState(false);
//   const [isLoadingRoute, setIsLoadingRoute] = useState(false);
//   const [isTripEnded, setIsTripEnded] = useState(false);
//   const [driverFilterType, setDriverFilterType] = useState("All");
//   const [filteredDriverData, setFilteredDriverData] = useState([]);
//   const [servicesTabbarValue, setServicesTabbarValue] = useState(0);
//   const [isExpanded, setIsExpanded] = useState(false);

//   const [isSearchActive, setIsSearchActive] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [trpID, setTrpID] = useState(null);
//   const [copiedItemId, setCopiedItemId] = useState(null);
//   const searchInputRef = useRef();
//   const history = useHistory();

//   const TripStatusText = {
//     "-4": "CANCEL_BY_RIDER",
//     "-3": "CANCEL_BY_DRIVER",
//     "-2": "CANCEL_BY_ADMIN",
//     "-1": "REJECT",
//     1: "REQUEST",
//     2: "ACCEPT",
//     3: "START_PICKUP",
//     4: "END_PICKUP",
//     5: "START_TRIP",
//     6: "STOP_PASS",
//     7: "END_TRIP",
//     8: "INVOICE",
//     9: "RATING",
//   };

//   useEffect(() => {
//     // debugger;
//     if (props?.driverData?.length > 0 && !props.isLoading) {
//       const approvedDrivers = props?.driverData?.filter(
//         (driver) => driver?.isApproved === true
//       );
//       // setFilteredDriverData(props.driverData);
//       setFilteredDriverData(approvedDrivers);
//     }
//   }, [props.driverData, props.isLoading]);

//   function transition() {
//     i = 0;
//     deltaLat =
//       (flightPlanCoordinates[flightPlanCoordinates?.length - 1].lat -
//         flightPlanCoordinates[flightPlanCoordinates?.length - 2].lat) /
//       numDeltas;
//     deltaLng =
//       (flightPlanCoordinates[flightPlanCoordinates?.length - 1].lng -
//         flightPlanCoordinates[flightPlanCoordinates?.length - 2].lng) /
//       numDeltas;
//     moveMarker();
//   }

//   function moveMarker() {
//     flightPlanCoordinates[flightPlanCoordinates?.length - 2].lat += deltaLat;
//     flightPlanCoordinates[flightPlanCoordinates?.length - 2].lng += deltaLng;
//     var latlng = new window.google.maps.LatLng(
//       flightPlanCoordinates[flightPlanCoordinates?.length - 2].lat,
//       flightPlanCoordinates[flightPlanCoordinates?.length - 2].lng
//     );
//     marker.setPosition(latlng);
//     if (i != numDeltas) {
//       i++;
//       setTimeout(moveMarker, delay);
//     }
//   }

//   useEffect(() => {
//     prev_driverEmail = "";
//     riderDetails = [];
//   }, []);

//   useEffect(() => {
//     const script = document.createElement("script");
//     script.src =
//       "https://maps.googleapis.com/maps/api/js?key=AIzaSyDHdkmGjsfNqasFs6m9CooShFZsqWHcdUs&callback=myInitMap&libraries=places&v=weekly";
//     script.async = true;
//     document.body.appendChild(script);
//   }, [onTripDriverEmail, driverFilterType]);

//   if (
//     (prev_driverEmail && prev_driverEmail !== onTripDriverEmail && myFlag) ||
//     (prev_driverEmail == null && onTripDriverEmail == null)
//   ) {
//     // console.log("here", trip_interval);
//     clearIntervalApiCall();
//     clearIntervalFligthPath();
//     // intervalApiCall();
//     setTimeout(() => {
//       flightPathInterval();
//     });
//     myFlag = 0;
//   } else myFlag = 1;

//   useEffect(() => {
//     if (typeof window.google !== "undefined" && window.google.maps) {
//       // Proceed with your logic to use google.maps
//       let driverDetails = props?.driverData;

//       onlineDriversMarker.forEach((marker) => marker?.setMap(null));
//       onlineDriversMarker = [];
//       const infoWindow = new window.google.maps.InfoWindow();

//       driverDetails.forEach((driver, i) => {
//         if (driver.lastLL !== null) {
//           const titleContent = `
//           <div style="display: flex; flex-direction: column; gap: 2px; min-width: 120px;">
//       <div style="font-size: 14px; font-weight: bold;">
//         ${driver.driverName}
//       </div>
//       <div style="font-size: 11px; color: gray;">
//         ${driver.lastUpdatedAt}
//       </div>
//       </div>
//     `;
//           onlineDriversMarker[i] = new window.google.maps.Marker({
//             position: {
//               lat: parseFloat(driver?.lastLL?.split(",")[0]),
//               lng: parseFloat(driver?.lastLL?.split(",")[1]),
//             },
//             map,
//             icon: {
//               url: carIcon,
//               scaledSize: new window.google.maps.Size(34, 34),
//               anchor: new window.google.maps.Point(17, 17),
//             },
//             myTitle: `${driver.driverName}`,
//             Title: `${driver.driverName}`,
//           });
//           onlineDriversMarker[i]?.addListener("click", () => {
//             //   infoWindow.close();
//             //   infoWindow.setHeaderContent(onlineDriversMarker[i].myTitle);
//             //   infoWindow.open(
//             //     onlineDriversMarker[i].getMap(),
//             //     onlineDriversMarker[i]
//             //   );
//             // });
//             infoWindow.close();
//             infoWindow.setHeaderContent(onlineDriversMarker[i].myTitle);
//             infoWindow.setContent(`On ${driver.lastUpdatedAt}`);
//             infoWindow.open(
//               onlineDriversMarker[i].getMap(),
//               onlineDriversMarker[i]
//             );
//           });
//         }
//       });
//       setIsLoadingRoute(false);
//     } else {
//       console.error("Google Maps API is not loaded yet.");
//     }
//   }, [props?.driverData, onTripDriverEmail]);

//   function animateMarkerTo(
//     marker,
//     newLat,
//     newLng,
//     duration,
//     onComplete = () => {}
//   ) {
//     const startPosition = marker.getPosition();
//     const startLat = startPosition.lat();
//     const startLng = startPosition.lng();

//     const deltaLat = newLat - startLat;
//     const deltaLng = newLng - startLng;

//     const steps = 100;
//     const stepDuration = duration / steps;
//     let currentStep = 0;

//     function step() {
//       currentStep++;
//       const progress = currentStep / steps;

//       const intermediateLat = startLat + deltaLat * progress;
//       const intermediateLng = startLng + deltaLng * progress;

//       const newPosition = new window.google.maps.LatLng(
//         intermediateLat,
//         intermediateLng
//       );
//       marker.setPosition(newPosition);

//       // 👇 Extend polyline during animation, for smooth drawing
//       flightPlanCoordinates.push({
//         lat: intermediateLat,
//         lng: intermediateLng,
//       });

//       if (currentStep < steps) {
//         setTimeout(step, stepDuration);
//       } else {
//         marker.setPosition(new window.google.maps.LatLng(newLat, newLng));
//         onComplete(); // Call the callback once done
//       }
//     }

//     step();
//   }

//   // const authenticateUser = (response) => {

//   //   if (!tripIdOfOnTrip) {
//   //     const lastLL = response?.DriverList?.LastLL;

//   //     if (lastLL) {
//   //       const [latStr, lngStr] = lastLL.split(",") || [];
//   //       const lat = parseFloat(latStr) || 0;
//   //       const lng = parseFloat(lngStr) || 0;

//   //       if (lat && lng) {
//   //         if (!marker) {
//   //           marker = new window.google.maps.Marker({
//   //             position: { lat, lng },
//   //             map,
//   //             icon: {
//   //               url: carIcon,
//   //               scaledSize: new window.google.maps.Size(40, 40),
//   //             },
//   //           });
//   //         } else {
//   //           // marker.setPosition({ lat, lng });
//   //           animateMarkerTo(marker, lat, lng, 20000); // 20 seconds

//   //         }

//   //         map.setCenter({ lat, lng });
//   //         map.setZoom(15);
//   //       }
//   //     } else {
//   //       console.warn("LastLL is missing or invalid in response:", response);
//   //     }

//   //     return;
//   //   }

//   //   let data = response?.data;
//   //   if (!onTripDriverEmail) return;

//   //   const tripLocations = data?.TripLocations;
//   //   if (tripLocations) {
//   //       // Convert to array if it's not already one
//   //       const locationsArray = Array.isArray(tripLocations) ?
//   //           tripLocations :
//   //           [tripLocations]; // Wrap single object in array

//   //   if (locationsArray.length > 0) {
//   //     const latestLocation = locationsArray[locationsArray.length - 1];
//   //     const lat = parseFloat(latestLocation?.LL?.split(",")?.[0]) || 0;
//   //     const lng = parseFloat(latestLocation?.LL?.split(",")?.[1]) || 0;
//   //     if (!driverFlag) {
//   //       const lastCoord =
//   //         flightPlanCoordinates[flightPlanCoordinates.length - 1];

//   //       if (
//   //         !flightPlanCoordinates.length ||
//   //         !lastCoord ||
//   //         lastCoord.lat !== lat ||
//   //         lastCoord.lng !== lng
//   //       ) {

//   //         flightPlanCoordinates.push({ lat, lng });

//   //         // Add or move the marker
//   //         if (!marker) {
//   //           marker = new window.google.maps.Marker({
//   //             position: { lat, lng },
//   //             map,
//   //             icon: {
//   //               url: carIcon,
//   //               scaledSize: new window.google.maps.Size(40, 40),
//   //             },
//   //           });
//   //         } else {
//   //           // marker.setPosition({ lat, lng });
//   //           animateMarkerTo(marker, lat, lng, 20000); // 20 seconds
//   //         }

//   //         // Rotate car image
//   //         const markerImg = document.querySelector(`[src="${carIcon}"]`);
//   //         if (markerImg) {
//   //           markerImg.style.transform = `rotate(${latestLocation.Bearing}deg)`;
//   //         }
//   //       }
//   //     } else {
//   //       // First load: full route
//   //       flightPlanCoordinates = [];
//   //       locationsArray.forEach((location) => {
//   //         const lat = parseFloat(location?.LL?.split(",")?.[0]) || 0;
//   //         const lng = parseFloat(location?.LL?.split(",")?.[1]) || 0;
//   //         flightPlanCoordinates.push({ lat, lng });
//   //       });

//   //       drawLineFlag = true;
//   //       driverFlag = false;

//   //       // Set marker at latest location
//   //       if (flightPlanCoordinates.length > 0) {
//   //         const final = flightPlanCoordinates[flightPlanCoordinates.length - 1];
//   //         if (!marker) {
//   //           marker = new window.google.maps.Marker({
//   //             position: final,
//   //             map,
//   //             icon: {
//   //               url: carIcon,
//   //               scaledSize: new window.google.maps.Size(40, 40),
//   //             },
//   //           });
//   //         } else {
//   //           // marker.setPosition(final);
//   //           animateMarkerTo(marker, final, 20000); // 20 seconds

//   //         }

//   //         const markerImg = document.querySelector(`[src="${carIcon}"]`);
//   //         if (markerImg) {
//   //           markerImg.style.transform = `rotate(${latestLocation.Bearing}deg)`;
//   //         }
//   //       }
//   //     }
//   //     // driverFlag = false;

//   //     journeyStart = 1;
//   //     setIsTripEnded(false);
//   //   }} else if (data?.LivetripStatus?.toLowerCase() === "ended") {
//   //     setIsTripEnded(true);
//   //     flightPlanCoordinates = [];
//   //     if (marker) {
//   //       marker.setMap(null);
//   //       marker = null;
//   //     }
//   //   } else {
//   //     setIsTripEnded(false);
//   //   }

//   //   const getTripStatusText = (statusNumber) => {
//   //     return TripStatusText[statusNumber] || "UNKNOWN_STATUS";
//   //   };

//   //   const tripStatus = getTripStatusText(data?.data?.TripStatus)?.toLowerCase();
//   //   if (!(tripStatus === "ended" || tripStatus === "arrived")) {
//   //     if (startPointMarker) startPointMarker.setMap(null);
//   //     if (endPointMarker) endPointMarker.setMap(null);

//   //     riderDetails = riderDetails.length === 0 ? [] : riderDetails;

//   //     let tripDetails = data?.data;
//   //     const newRiders = data?.tripDetails?.TripRiders || [];

//   //     const uniqueRiders = newRiders.filter(
//   //       (newRider) =>
//   //         !riderDetails.some(
//   //           (existingRider) => existingRider.RiderID === newRider.RiderID
//   //         )
//   //     );

//   //     riderDetails = [...riderDetails, ...uniqueRiders];

//   //     const pickupLat =
//   //       parseFloat(tripDetails?.ActualPickupLatLng?.split(",")?.[0]) ||
//   //       parseFloat(tripDetails?.PickupLatLng?.split(",")?.[0]) ||
//   //       0;
//   //     const pickupLng =
//   //       parseFloat(tripDetails?.ActualPickupLatLng?.split(",")?.[1]) ||
//   //       parseFloat(tripDetails?.PickupLatLng?.split(",")?.[1]) ||
//   //       0;

//   //     if (pickupLat !== 0 || pickupLng !== 0) {
//   //       startPointMarker = new window.google.maps.Marker({
//   //         position: { lat: pickupLat, lng: pickupLng },
//   //         map,
//   //         icon: startPoint,
//   //         myTitle:
//   //           tripDetails?.ActualPickupName ||
//   //           tripDetails?.PickupAddress ||
//   //           "Pickup",
//   //       });
//   //     }

//   //     const dropLat =
//   //       parseFloat(tripDetails?.ActualDropOffLatLng?.split(",")?.[0]) ||
//   //       parseFloat(tripDetails?.DropOffLatLng?.split(",")?.[0]) ||
//   //       0;
//   //     const dropLng =
//   //       parseFloat(tripDetails?.ActualDropOffLatLng?.split(",")?.[1]) ||
//   //       parseFloat(tripDetails?.DropOffLatLng?.split(",")?.[1]) ||
//   //       0;

//   //     endPointMarker = new window.google.maps.Marker({
//   //       position: { lat: dropLat, lng: dropLng },
//   //       map,
//   //       icon: endPoint,
//   //       myTitle: tripDetails?.DropOffAddress || "Dropoff",
//   //     });

//   //     const bounds = new window.google.maps.LatLngBounds();
//   //     bounds.extend(new window.google.maps.LatLng(pickupLat, pickupLng));
//   //     bounds.extend(new window.google.maps.LatLng(dropLat, dropLng));

//   //     const infoWindow = new window.google.maps.InfoWindow();

//   //     startPointMarker?.addListener("mouseover", () => {
//   //       infoWindow.close();
//   //       infoWindow.setHeaderContent(startPointMarker.myTitle);
//   //       infoWindow.open(startPointMarker.getMap(), startPointMarker);
//   //     });

//   //     endPointMarker?.addListener("mouseover", () => {
//   //       infoWindow.close();
//   //       infoWindow.setHeaderContent(endPointMarker.myTitle);
//   //       infoWindow.open(endPointMarker.getMap(), endPointMarker);
//   //     });
//   //   }

//   //   setIsLoadingRoute(false);
//   // };

//   const authenticateUser = (response) => {
//     if (!tripIdOfOnTrip) {
//       const lastLL = response?.DriverList?.LastLL;
//       if (lastLL) {
//         const [latStr, lngStr] = lastLL.split(",") || [];
//         const lat = parseFloat(latStr) || 0;
//         const lng = parseFloat(lngStr) || 0;
//         if (lat && lng) {
//           if (!marker) {
//             marker = new window.google.maps.Marker({
//               position: { lat, lng },
//               map,
//               icon: {
//                 url: carIcon,
//                 scaledSize: new window.google.maps.Size(40, 40),
//               },
//             });
//           } else {
//             animateMarkerTo(marker, lat, lng, 20000);
//           }

//           map.setCenter({ lat, lng });
//           map.setZoom(15);
//         }
//       }
//       return;
//     }

//     const data = response?.data;
//     if (!onTripDriverEmail) return;

//     const tripLocations = Array.isArray(data?.TripLocations)
//       ? data?.TripLocations
//       : [data?.TripLocations];

//     if (tripLocations?.length > 0) {
//       const latestLocation = tripLocations[tripLocations.length - 1];
//       const lat = parseFloat(latestLocation?.LL?.split(",")?.[0]) || 0;
//       const lng = parseFloat(latestLocation?.LL?.split(",")?.[1]) || 0;
//       const bearing = latestLocation?.Bearing || 0;

//       if (!driverFlag) {
//         const lastCoord = flightPlanCoordinates.at(-1);

//         // if (!lastCoord || lastCoord.lat !== lat || lastCoord.lng !== lng) {
//         //   const updatePath = () => {
//         //     flightPlanCoordinates.push({ lat, lng });

//         //     const markerImg = document.querySelector(`[src="${carIcon}"]`);
//         //     if (markerImg) markerImg.style.transform = `rotate(${bearing}deg)`;
//         //   };

//         //   if (!marker) {
//         //     marker = new window.google.maps.Marker({
//         //       position: { lat, lng },
//         //       map,
//         //       icon: {
//         //         url: carIcon,
//         //         scaledSize: new window.google.maps.Size(40, 40),
//         //       },
//         //     });
//         //     updatePath();
//         //   } else {
//         //     animateMarkerTo(marker, lat, lng, 20000, updatePath);
//         //   }
//         // }

//         if (!lastCoord || lastCoord.lat !== lat || lastCoord.lng !== lng) {
//           const onAnimationComplete = () => {
//             flightPlanCoordinates.push({ lat, lng });

//             // Apply bearing rotation *after* smooth move
//             const markerImg = document.querySelector(`[src="${carIcon}"]`);
//             if (markerImg) markerImg.style.transform = `rotate(${bearing}deg)`;
//           };

//           if (!marker) {
//             marker = new window.google.maps.Marker({
//               position: { lat, lng },
//               map,
//               icon: {
//                 url: carIcon,
//                 scaledSize: new window.google.maps.Size(40, 40),
//               },
//             });

//             // Don't push path until marker is fully placed
//             onAnimationComplete();
//           } else {
//             // Move smoothly, then update path
//             animateMarkerTo(marker, lat, lng, 20000, onAnimationComplete);
//           }
//         }
//       } else {
//         // First load of trip data
//         flightPlanCoordinates = tripLocations.map((loc) => {
//           const [latStr, lngStr] = loc?.LL?.split(",") || [0, 0];
//           return {
//             lat: parseFloat(latStr) || 0,
//             lng: parseFloat(lngStr) || 0,
//           };
//         });

//         driverFlag = false;
//         drawLineFlag = true;

//         const final = flightPlanCoordinates.at(-1);
//         if (!marker) {
//           marker = new window.google.maps.Marker({
//             position: final,
//             map,
//             icon: {
//               url: carIcon,
//               scaledSize: new window.google.maps.Size(40, 40),
//             },
//           });
//         } else {
//           animateMarkerTo(marker, final.lat, final.lng, 20000);
//         }

//         const markerImg = document.querySelector(`[src="${carIcon}"]`);
//         if (markerImg) markerImg.style.transform = `rotate(${bearing}deg)`;
//       }

//       journeyStart = 1;
//       setIsTripEnded(false);
//     } else if (data?.LivetripStatus?.toLowerCase() === "ended") {
//       setIsTripEnded(true);
//       flightPlanCoordinates = [];

//       if (marker) {
//         marker.setMap(null);
//         marker = null;
//       }
//     } else {
//       setIsTripEnded(false);
//     }

//     const getTripStatusText = (statusNumber) => {
//       return TripStatusText[statusNumber] || "UNKNOWN_STATUS";
//     };

//     const tripStatus = getTripStatusText(data?.data?.TripStatus)?.toLowerCase();
//     if (!(tripStatus === "ended" || tripStatus === "arrived")) {
//       if (startPointMarker) startPointMarker.setMap(null);
//       if (endPointMarker) endPointMarker.setMap(null);

//       riderDetails = riderDetails.length === 0 ? [] : riderDetails;

//       let tripDetails = data?.data;
//       const newRiders = data?.tripDetails?.TripRiders || [];

//       const uniqueRiders = newRiders.filter(
//         (newRider) =>
//           !riderDetails.some(
//             (existingRider) => existingRider.RiderID === newRider.RiderID
//           )
//       );

//       riderDetails = [...riderDetails, ...uniqueRiders];

//       const pickupLat =
//         parseFloat(tripDetails?.ActualPickupLatLng?.split(",")?.[0]) ||
//         parseFloat(tripDetails?.PickupLatLng?.split(",")?.[0]) ||
//         0;
//       const pickupLng =
//         parseFloat(tripDetails?.ActualPickupLatLng?.split(",")?.[1]) ||
//         parseFloat(tripDetails?.PickupLatLng?.split(",")?.[1]) ||
//         0;

//       if (pickupLat !== 0 || pickupLng !== 0) {
//         startPointMarker = new window.google.maps.Marker({
//           position: { lat: pickupLat, lng: pickupLng },
//           map,
//           icon: startPoint,
//           myTitle:
//             tripDetails?.ActualPickupName ||
//             tripDetails?.PickupAddress ||
//             "Pickup",
//         });
//       }

//       const dropLat =
//         parseFloat(tripDetails?.ActualDropOffLatLng?.split(",")?.[0]) ||
//         parseFloat(tripDetails?.DropOffLatLng?.split(",")?.[0]) ||
//         0;
//       const dropLng =
//         parseFloat(tripDetails?.ActualDropOffLatLng?.split(",")?.[1]) ||
//         parseFloat(tripDetails?.DropOffLatLng?.split(",")?.[1]) ||
//         0;

//       endPointMarker = new window.google.maps.Marker({
//         position: { lat: dropLat, lng: dropLng },
//         map,
//         icon: endPoint,
//         myTitle: tripDetails?.DropOffAddress || "Dropoff",
//       });

//       const bounds = new window.google.maps.LatLngBounds();
//       bounds.extend(new window.google.maps.LatLng(pickupLat, pickupLng));
//       bounds.extend(new window.google.maps.LatLng(dropLat, dropLng));

//       const infoWindow = new window.google.maps.InfoWindow();

//       startPointMarker?.addListener("mouseover", () => {
//         infoWindow.close();
//         infoWindow.setHeaderContent(startPointMarker.myTitle);
//         infoWindow.open(startPointMarker.getMap(), startPointMarker);
//       });

//       endPointMarker?.addListener("mouseover", () => {
//         infoWindow.close();
//         infoWindow.setHeaderContent(endPointMarker.myTitle);
//         infoWindow.open(endPointMarker.getMap(), endPointMarker);
//       });
//     }
//     setIsLoadingRoute(false);
//   };

//   const { isLoading, sendRequest } = useHttp();

//   const location = useLocation();

//   function intervalApiCall() {
//     flightPlanCoordinates = [];

//     // Initial flag setup
//     if (prev_driverEmail == null) {
//       driverFlag = true;
//     } else {
//       driverFlag = prev_driverEmail !== onTripDriverEmail;
//     }
//     prev_driverEmail = onTripDriverEmail;

//     // First call with all locations
//     sendRequest(
//       {
//         url: "/trip",
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: {
//           emailID: localStorage.getItem("user"),
//           data: { LocationCount: 9999, tripID: tripIdOfOnTrip },
//         },
//       },
//       authenticateUser
//     );

//     // Set up interval for updates
//     trip_interval = setInterval(() => {
//       sendRequest(
//         {
//           url: "/trip",
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: {
//             emailID: localStorage.getItem("user"),
//             data: { tripID: tripIdOfOnTrip, LocationCount: 1 },
//           },
//         },
//         authenticateUser
//       );
//     }, 20000);

//     sessionStorage.setItem("interval", trip_interval);
//   }

//   function clearIntervalApiCall() {
//     riderDetails = [];
//     clearInterval(trip_interval);
//     emailFlag = true;
//   }

//   function clearIntervalFligthPath() {
//     marker?.setMap(null);
//     clearInterval(pathInterval);
//     // flightPath1?.setMap(null);
//     flightPath2?.setMap(null);
//   }

//   // function flightPathInterval() {
//   //   if (!onTripDriverEmail) {
//   //     flightPlanCoordinates = [];
//   //   }
//   //   if (onTripDriverEmail == null) {
//   //     flightPath2 = new window.google.maps.Polyline({
//   //       path: flightPlanCoordinates,
//   //     });
//   //   } else {
//   //     marker = new window.google.maps.Marker({
//   //       position: flightPlanCoordinates[flightPlanCoordinates?.length - 1],
//   //       map,
//   //       icon: {
//   //         url: carIcon,
//   //         scaledSize: new window.google.maps.Size(34, 34),
//   //         anchor: new window.google.maps.Point(17, 17),
//   //       },
//   //       optimized: false,
//   //     });

//   //     pathInterval = setInterval(() => {
//   //       flightPath2 = new window.google.maps.Polyline({
//   //         path: flightPlanCoordinates,
//   //         // geodesic: true,
//   //         strokeColor: "#00b0ff",
//   //         strokeOpacity: 10.0,
//   //         strokeWeight: 3,
//   //       });

//   //       if (document.getElementsByClassName("gm-fullscreen-control")[0])
//   //         document.getElementsByClassName(
//   //           "gm-fullscreen-control"
//   //         )[0].style.marginTop = "45px";
//   //       if (flightPlanCoordinates?.length > 1) {
//   //         flightPath2?.setMap(null);
//   //         flightPath2.setMap(map);
//   //         marker.setPosition(
//   //           flightPlanCoordinates[flightPlanCoordinates?.length - 1]
//   //         );
//   //       } else if (flightPlanCoordinates?.length > 0) {
//   //         flightPath2?.setMap(null);
//   //         flightPath2.setMap(map);
//   //         marker.setPosition(
//   //           flightPlanCoordinates[flightPlanCoordinates?.length - 1]
//   //         );
//   //       }
//   //       if (
//   //         (prev_driverEmail || prev_driverEmail == null) &&
//   //         emailFlag &&
//   //         flightPlanCoordinates[flightPlanCoordinates?.length - 1]?.lat
//   //       ) {
//   //         map.setCenter({
//   //           lat: flightPlanCoordinates[flightPlanCoordinates?.length - 1]?.lat,
//   //           lng: flightPlanCoordinates[flightPlanCoordinates?.length - 1]?.lng,
//   //         });
//   //         map.setZoom(14);
//   //         emailFlag = false;
//   //       } else if (
//   //         !flightPlanCoordinates[flightPlanCoordinates?.length - 1]?.lat
//   //       ) {
//   //       }
//   //       drawLineFlag = false;
//   //     }, 2000);
//   //     // },{LiveLocationCallDuration});
//   //   }
//   // }

//   function flightPathInterval() {
//     if (!onTripDriverEmail) {
//       flightPlanCoordinates = [];
//     }

//     if (!onTripDriverEmail) {
//       flightPath2 = new window.google.maps.Polyline({
//         path: flightPlanCoordinates,
//       });
//     } else {
//       marker = new window.google.maps.Marker({
//         position: flightPlanCoordinates.at(-1),
//         map,
//         icon: {
//           url: carIcon,
//           scaledSize: new window.google.maps.Size(34, 34),
//           anchor: new window.google.maps.Point(17, 17),
//         },
//         optimized: false,
//       });

//       pathInterval = setInterval(() => {
//         if (flightPlanCoordinates.length === 0) return;

//         if (flightPath2) flightPath2.setMap(null);

//         flightPath2 = new window.google.maps.Polyline({
//           path: flightPlanCoordinates,
//           strokeColor: "#00b0ff",
//           strokeOpacity: 1.0,
//           strokeWeight: 3,
//         });

//         flightPath2.setMap(map);

//         const latest = flightPlanCoordinates.at(-1);
//         marker.setPosition(latest);

//         if (
//           (prev_driverEmail || prev_driverEmail == null) &&
//           emailFlag &&
//           latest?.lat
//         ) {
//           map.setCenter({ lat: latest.lat, lng: latest.lng });
//           map.setZoom(14);
//           emailFlag = false;
//         }

//         drawLineFlag = false;
//       }, 2000);
//     }
//   }

//   function myInitMap() {
//     map = new window.google.maps.Map(document.getElementById("live-map"), {
//       center: { lat: 23.0225, lng: 72.5714 },
//       zoom: 12,
//       disableDefaultUI: true,
//       fullscreenControl: true,
//       zoomControl: true,
//     });
//     flightPathInterval();
//   }

//   window.myInitMap = myInitMap;

//   const driverSearchHandler = (e) => {
//     setFilteredDriverData(
//       props.driverData.filter(
//         (data) =>
//           data.driverName
//             ?.toLowerCase()
//             .includes(e.target.value.toLowerCase()) ||
//           data.carNumber?.toLowerCase().includes(e.target.value.toLowerCase())
//       )
//     );
//   };

//   const onTripDriverClickHandler = (
//     driverEmail,
//     isOnTrip,
//     driverName,
//     tripId
//   ) => {
//     if (!tripIdOfOnTrip) {
//       sendRequest(
//         {
//           // url: "/api/v1/Trips/GetTripDetails",
//           url: "/corporatedriver",
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: {
//             emailID: localStorage.getItem("user"),
//             data: {
//               emailID: driverEmail,
//             },
//           },
//         },
//         authenticateUser
//       );
//     }
//     if (isOnTrip == "1") {
//       prev_driverId = driverEmail;
//       onTripDriverName = driverName;
//       // prev_driverEmail=driverEmail

//       riderDetails = [];
//       setOnTripDriverEmail(driverEmail);
//       setIsLoadingRoute(true);
//       setTrpID(tripId);
//     }
//   };

//   const bookButtonClickHandler = (
//     driverImage,
//     driverName,
//     carNumber,
//     carType,
//     driverType,
//     driverEmail,
//     carModel,
//     carColor,
//     activeShiftCororateName,
//     activeShiftCorporateId
//   ) => {
//     setBookedDriver([
//       {
//         driverImage,
//         driverName,
//         carNumber,
//         carType,
//         driverType,
//         driverEmail,
//         carModel,
//         carColor,
//         activeShiftCororateName,
//         activeShiftCorporateId,
//       },
//     ]);
//   };

//   const toggleExpand = () => {
//     setIsExpanded(!isExpanded);
//   };

//   const firstRider = riderDetails?.[0];
//   const restRiders = riderDetails?.slice(1);

//   const handleSearchClick = () => {
//     setIsSearchActive(true);
//     setTimeout(() => {
//       if (searchInputRef.current) {
//         searchInputRef.current.focus();
//       }
//     }, 100);
//   };

//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//     setFilteredDriverData(
//       props.driverData.filter((data) =>
//         data.driverName.toLowerCase().includes(e.target.value.toLowerCase())
//       )
//     );
//   };

//   const clearSearch = () => {
//     setSearchQuery("");
//     setFilteredDriverData(props.driverData); // Reset filtered data to all drivers
//     if (searchInputRef.current) {
//       searchInputRef.current.focus();
//       setIsSearchActive(false);
//     }
//   };

//   const handleCopyClick = (event, shuttleId) => {
//     event.stopPropagation(); // Ensure event propagation is stopped
//     navigator.clipboard.writeText(shuttleId); // Verify clipboard write operation
//     setCopiedItemId(shuttleId); // Check if copiedItemId is correctly set
//     setTimeout(() => {
//       setCopiedItemId(shuttleId); // Reset copiedItemId after timeout
//     }, 1);
//   };

//   return (
//     <React.Fragment>
//       {bookedDriver && <div className="backdrop"></div>}
//       <div
//         className="main-container"
//         id="privatedriver"
//         style={props.toggle ? { padding: "15px 0px" } : {}}
//       >
//         <div
//           className="driverlist"
//           style={{
//             pointerEvents: isLoadingRoute ? "none" : "auto",
//             opacity: isLoadingRoute ? "0.7" : "1",
//           }}
//         >
//           <div className="header">
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 height: "25px",
//               }}
//             >
//               {!isSearchActive && (
//                 <>
//                   <p
//                     style={{
//                       fontFamily: "Poppins",
//                       fontSize: "16px",
//                       fontWeight: "300",
//                       // margin: "0",
//                     }}
//                   >
//                     Driver List
//                   </p>
//                   <div
//                     onClick={handleSearchClick}
//                     style={{ cursor: "pointer" }}
//                   >
//                     <CiSearch style={{ fontSize: "20px" }} />
//                     {/* <FaSearch /> */}
//                   </div>
//                 </>
//               )}
//               {isSearchActive && (
//                 <div style={{ display: "flex", gap: "42px" }}>
//                   <div>
//                     <TextField
//                       type="text"
//                       ref={searchInputRef}
//                       value={searchQuery}
//                       autoFocus
//                       onChange={handleSearchChange}
//                       placeholder="Search Drivers"
//                       style={{ fontSize: "10px", width: "120%" }}
//                       InputProps={{
//                         startAdornment: (
//                           <CiSearch
//                             style={{
//                               fontSize: "18px",
//                               marginRight: "8px",
//                               color: "#999",
//                             }}
//                           />
//                         ),
//                       }}
//                       variant="standard"
//                     />
//                   </div>
//                   <div
//                     onClick={clearSearch}
//                     style={{ cursor: "pointer", alignContent: "center" }}
//                   >
//                     <FaTimes style={{ color: "#D83434", fontSize: "16px" }} />
//                   </div>
//                 </div>
//               )}
//             </div>

//             <div className="driver-filter">
//               <Tabs
//                 variant="fullWidth"
//                 sx={{
//                   button: { padding: "0", fontSize: "12px" },
//                   div: { minHeight: "35px" },
//                   span: { bottom: "5px" },
//                 }}
//                 style={{ cursor: "pointer" }}
//                 centered
//                 value={servicesTabbarValue}
//                 onChange={(e, newValue) => {
//                   if (newValue == "0")
//                     // setFilteredDriverData(props.driverData.filter(data => data.driverName.toLowerCase().includes(searchInputRef?.current?.value?.toLowerCase())));
//                     setFilteredDriverData(props.driverData);
//                   else if (newValue == "2")
//                     setFilteredDriverData(
//                       props.driverData.filter((data) => data?.isOnTrip == "1")
//                     );
//                   else if (newValue == "1")
//                     setFilteredDriverData(
//                       props.driverData.filter(
//                         (data) => data?.isOnline == "1" && data?.isOnTrip == "0"
//                       )
//                     );
//                   setDriverFilterType(
//                     newValue == "0"
//                       ? "All"
//                       : newValue == "1"
//                       ? "Online"
//                       : "On Trip"
//                   );
//                   setOnTripDriverEmail("");
//                   setServicesTabbarValue(newValue);
//                 }}
//                 aria-label="basic tabs example"
//               >
//                 <Tab
//                   label="All"
//                   // style={{ fontWeight: "bold" }}
//                   // sx={{ button: { minHeight: "35px" } }}
//                   sx={{
//                     fontWeight: "bold",
//                     minHeight: "35px",
//                     "&:hover": {
//                       backgroundColor: "#D3D3D3",
//                       color: "black",
//                     },
//                     "&.Mui-selected": {
//                       color: "#1976d2",
//                     },
//                   }}
//                 />
//                 <Tab
//                   label="Online"
//                   // style={{ fontWeight: "bold" }}
//                   // sx={{ button: { minHeight: "35px" } }}
//                   sx={{
//                     fontWeight: "bold",
//                     minHeight: "35px",
//                     "&:hover": {
//                       backgroundColor: "#D3D3D3",
//                       color: "black",
//                     },
//                     "&.Mui-selected": {
//                       color: "#1976d2",
//                     },
//                   }}
//                 />
//                 <Tab
//                   label="On Trip"
//                   // style={{ fontWeight: "bold" }}
//                   // sx={{ button: { minHeight: "35px" } }}
//                   sx={{
//                     fontWeight: "bold",
//                     minHeight: "35px",
//                     "&:hover": {
//                       backgroundColor: "#D3D3D3",
//                       color: "black",
//                     },
//                     "&.Mui-selected": {
//                       color: "#1976d2",
//                     },
//                   }}
//                 />
//               </Tabs>
//             </div>
//           </div>
//           <div className="driverDetails">
//             {props.isLoading && (
//               <CircularProgress
//                 sx={{
//                   position: "absolute",
//                   top: "40%",
//                   left: "45%",
//                   transform: "translate(-50%,-50%)",
//                 }}
//               />
//             )}
//             {filteredDriverData?.length < 1 && !props.isLoading && (
//               <div style={{ textAlign: "center", marginTop: "20px" }}>
//                 No Drivers Available
//               </div>
//             )}
//             {filteredDriverData?.map((ele) => {
//               return (
//                 <div
//                   id={ele.driverEmail}
//                   key={ele.driverEmail}
//                   className={`driverSingleData ${
//                     ele.isOnTrip == "1" ? "driverContainer" : ""
//                   } ${
//                     onTripDriverEmail === ele.driverEmail ? "currentDriver" : ""
//                   }`}
//                   onClick={() => {
//                     // Always set tripId on div click
//                     setTripIdOfOnTrip(ele?.tripId);

//                     // Handle on-trip driver click events
//                     onTripDriverClickHandler(
//                       ele?.driverEmail,
//                       ele?.isOnTrip,
//                       ele?.driverName,
//                       ele?.tripId
//                     );

//                     // Trigger bookButtonClickHandler only if the driver is either on a trip or both online and shift started
//                     if (
//                       ele?.isOnTrip != "1" &&
//                       ele?.isShiftStarted == "1" &&
//                       ele?.isOnline == "1" &&
//                       ele?.driverType.toLowerCase() == "private"
//                     ) {
//                       bookButtonClickHandler(
//                         ele?.driverImage,
//                         ele?.driverName,
//                         ele?.carNumber,
//                         ele?.vehicleType,
//                         ele?.driverType,
//                         ele?.driverEmail,
//                         ele?.carModel,
//                         ele?.carColor,
//                         ele?.activeShiftCororateName,
//                         ele?.activeShiftCorporateId,
//                         ele?.tripId
//                       );
//                     }
//                   }}
//                 >
//                   <div
//                     style={{
//                       display: "flex",
//                       gap: "10px",
//                       alignItems: "center",
//                     }}
//                   >
//                     <div style={{ position: "relative", alignSelf: "center" }}>
//                       <img className="driverPhoto" src={ele.driverImage} />
//                       <p
//                         className={
//                           ele?.isOnTrip == "1"
//                             ? "ontrip"
//                             : ele.isOnline == "1"
//                             ? "online"
//                             : "offline"
//                           // : "offline"
//                         }
//                       ></p>
//                     </div>
//                     <div style={{ display: "flex", flexDirection: "column" }}>
//                       <span className="drivername">{ele.driverName}</span>
//                       <span className="carnumber">
//                         {ele.carNumber.replaceAll("-", "")}
//                       </span>
//                       {(ele.isOnTrip == "1" ||
//                         (ele.isOnline == "1" && ele.isShiftStarted == "1")) && (
//                         <span
//                           style={{
//                             fontSize: "10px",
//                             fontFamily: "Poppins",
//                             textTransform: "capitalize",
//                             color: "gray",
//                           }}
//                         >
//                           {/* {ele.isOnTrip == "0" ? "private" : ele?.tripType} */}
//                           {ele?.driverType}
//                         </span>
//                       )}
//                       <div
//                         style={{
//                           display: "flex",
//                           gap: "10px",
//                           alignItems: "center",
//                         }}
//                       ></div>
//                     </div>
//                   </div>

//                   {(ele?.isOnline && ele?.isOnTrip == "1") ||
//                   (ele?.isOnline &&
//                     ele?.driverType.toLowerCase() === "private" &&
//                     ele?.isShiftStarted == "1") ? (
//                     <button
//                       className={
//                         ele?.isOnline && ele?.isOnTrip == "1"
//                           ? "onTripButtton"
//                           : ele?.driverType.toLowerCase() === "private"
//                           ? "bookButton"
//                           : null
//                       }
//                     >
//                       {ele?.isOnline && ele?.isOnTrip == "1"
//                         ? "On Trip"
//                         : ele?.driverType.toLowerCase() === "private"
//                         ? "Book"
//                         : ""}
//                     </button>
//                   ) : null}
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//         <div className="privateDriverMap-container">
//           <div className="mapText">
//             <span
//               style={{
//                 fontFamily: "Poppins",
//                 fontSize: "16px",
//                 fontWeight: "300",
//               }}
//             >
//               Live Trip Tracker
//             </span>
//           </div>
//           <div className="livetrip" id="live-map"></div>

//           {riderDetails?.length > 0 && (
//             <div
//               className="riderInfoContainer"
//               style={{
//                 border: "1px solid #ccc",
//                 padding: "0px 8px",
//                 borderRadius: "8px",
//                 width: "auto",
//                 height: "auto",
//                 // background:'transparent'
//                 opacity: "0.9",
//               }}
//             >
//               {/* New Code */}
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   // marginBottom: "8px",
//                   // marginTop: "4px",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     // gap: "10px",
//                     alignItems: "center",
//                     // marginBottom: "5px",
//                   }}
//                 >
//                   <Tooltip
//                     title={copiedItemId === trpID ? "Copied!" : "Copy Route ID"}
//                     arrow
//                   >
//                     <IconButton
//                       style={{ marginLeft: "-5%" }}
//                       onClick={(event) => handleCopyClick(event, trpID)}
//                     >
//                       <FileCopyIcon style={{ width: "14px" }} />
//                     </IconButton>
//                   </Tooltip>
//                   <div>
//                     <div> {trpID.substring(0, 8) + "..."}</div>
//                   </div>
//                 </div>
//               </div>

//               {/* New Code with the main Driver Name */}
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   // marginBottom: "8px",
//                   // marginTop: "4px",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     gap: "10px",
//                     alignItems: "center",
//                     marginBottom: "5px",
//                   }}
//                 >
//                   <FaRegUserCircle />
//                   <div>
//                     <div>{firstRider.RiderName}</div>
//                     <div style={{ fontSize: "11px", alignItems: "center" }}>
//                       {firstRider.MobileNumber}
//                     </div>
//                   </div>
//                   {restRiders.length > 1 && (
//                     <button
//                       onClick={toggleExpand}
//                       style={{
//                         border: "none",
//                         background: "none",
//                         cursor: "pointer",
//                       }}
//                     >
//                       {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
//                     </button>
//                   )}
//                 </div>
//               </div>

//               {isExpanded && restRiders.length > 0 && (
//                 <div
//                   className="additionalRiders"
//                   style={{ maxHeight: "200px", overflowY: "auto" }}
//                 >
//                   {restRiders?.map((rider, index) => (
//                     <div
//                       key={index}
//                       style={{
//                         display: "flex",
//                         flexDirection: "column",
//                         marginBottom: "8px",
//                         marginTop: "4px",
//                       }}
//                     >
//                       <div
//                         style={{
//                           display: "flex",
//                           gap: "10px",
//                           alignItems: "center",
//                           marginBottom: "5px",
//                         }}
//                       >
//                         <FaRegUserCircle />
//                         <div>
//                           <div>{rider.RiderName}</div>
//                           <div
//                             style={{ fontSize: "11px", alignItems: "center" }}
//                           >
//                             {rider.MobileNumber}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           )}

//           {isLoadingRoute && (
//             <div
//               style={{
//                 position: "absolute",
//                 top: "40px",
//                 left: "0",
//                 width: "100%",
//                 height: "calc(100% - 40px)",
//                 backgroundColor: "white",
//                 opacity: "0.5",
//               }}
//             ></div>
//           )}
//           {isLoadingRoute && <Loading driver="true" />}
//         </div>
//       </div>
//       {bookedDriver && (
//         <DriverBooking
//           bookedDriver={bookedDriver}
//           setBookedDriver={setBookedDriver}
//           riderData={props.riderData}
//           tripRequestStatusFunc={(status) => {
//             setTripRequestStatus(status);
//             setBookedDriver(false);
//           }}
//         />
//       )}
//       {isTripEnded && (
//         <Message
//           type="success"
//           message={onTripDriverName + "'s Trip has been ended"}
//         />
//       )}
//     </React.Fragment>
//   );
// };

// export default LiveTracking;

import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { FaRegUserCircle, FaTimes, FaSearch } from "react-icons/fa";
import { CiSearch } from "react-icons/ci";

import CircularProgress from "@mui/material/CircularProgress";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import useHttp from "../../Hooks/use-http";
import DriverBooking from "./PrivateDriverBooking";
import Loading from "../../Loading/Loading";
import Message from "../../Modal/Message";
import "./LiveTracking.css";
import startPoint from "../../Assets/dropIcon.png";
import endPoint from "../../Assets/pickIcon.png";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { IconButton, TextField, Tooltip, Popover, Box } from "@mui/material";
import { FileCopy as FileCopyIcon } from "@mui/icons-material";
import InfoIcon from "@mui/icons-material/Info";
// import { carIcon } from "../../Constant";
import carIcon from "../../Assets/live_car.png"; // Ensure this is a car icon image

let prev_driverEmail = "";
let flightPlanCoordinates = [];
let emailFlag = true;
let driverFlag = true;
let trip_interval = "";
let pathInterval = "";
let myFlag = 1;
let map;
let prev_driverId = "";
let flightPath1;
let flightPath2;
let marker = null;
let startPointMarker;
let endPointMarker;
var numDeltas = 100;
var delay = 20; //milliseconds
var i = 0;
var deltaLat;
var deltaLng;

let drawLineFlag = false;
let journeyStart = 0;
let onTripDriverName = "";
let onlineDriversMarker = [];
const LiveTracking = (props) => {
  const [bookedDriver, setBookedDriver] = useState(null);

  const [tripIdOfOnTrip, setTripIdOfOnTrip] = useState("");
  const [onTripDriverEmail, setOnTripDriverEmail] = useState(null);
  const [tripRequestStatus, setTripRequestStatus] = useState(false);
  const [isLoadingRoute, setIsLoadingRoute] = useState(false);
  const [isTripEnded, setIsTripEnded] = useState(false);
  const [driverFilterType, setDriverFilterType] = useState("All");
  const [filteredDriverData, setFilteredDriverData] = useState([]);
  const [servicesTabbarValue, setServicesTabbarValue] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);
  const [riderDetails, setRiderDetails] = useState([]);

  const [isSearchActive, setIsSearchActive] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [trpID, setTrpID] = useState(null);
  const [copiedItemId, setCopiedItemId] = useState(null);
  const [infoAnchorEl, setInfoAnchorEl] = useState(null);
  const searchInputRef = useRef();
  const history = useHistory();

  const TripStatusText = {
    "-4": "CANCEL_BY_RIDER",
    "-3": "CANCEL_BY_DRIVER",
    "-2": "CANCEL_BY_ADMIN",
    "-1": "REJECT",
    1: "REQUEST",
    2: "ACCEPT",
    3: "START_PICKUP",
    4: "END_PICKUP",
    5: "START_TRIP",
    6: "STOP_PASS",
    7: "END_TRIP",
    8: "INVOICE",
    9: "RATING",
  };

  useEffect(() => {
    // debugger;
    if (props?.driverData?.length > 0 && !props.isLoading) {
      const approvedDrivers = props?.driverData?.filter(
        (driver) => driver?.isApproved === true
      );
      // setFilteredDriverData(props.driverData);
      setFilteredDriverData(approvedDrivers);
    }
  }, [props.driverData, props.isLoading]);

  function transition() {
    i = 0;
    deltaLat =
      (flightPlanCoordinates[flightPlanCoordinates?.length - 1].lat -
        flightPlanCoordinates[flightPlanCoordinates?.length - 2].lat) /
      numDeltas;
    deltaLng =
      (flightPlanCoordinates[flightPlanCoordinates?.length - 1].lng -
        flightPlanCoordinates[flightPlanCoordinates?.length - 2].lng) /
      numDeltas;
    moveMarker();
  }

  function moveMarker() {
    flightPlanCoordinates[flightPlanCoordinates?.length - 2].lat += deltaLat;
    flightPlanCoordinates[flightPlanCoordinates?.length - 2].lng += deltaLng;
    var latlng = new window.google.maps.LatLng(
      flightPlanCoordinates[flightPlanCoordinates?.length - 2].lat,
      flightPlanCoordinates[flightPlanCoordinates?.length - 2].lng
    );
    marker.setPosition(latlng);
    if (i != numDeltas) {
      i++;
      setTimeout(moveMarker, delay);
    }
  }

  useEffect(() => {
    prev_driverEmail = "";
    setRiderDetails([]);
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyDHdkmGjsfNqasFs6m9CooShFZsqWHcdUs&callback=myInitMap&libraries=places&v=weekly";
    script.async = true;
    document.body.appendChild(script);
  }, [onTripDriverEmail, driverFilterType]);

  if (
    (prev_driverEmail && prev_driverEmail !== onTripDriverEmail && myFlag) ||
    (prev_driverEmail == null && onTripDriverEmail == null)
  ) {
    // console.log("here", trip_interval);
    clearIntervalApiCall();
    clearIntervalFligthPath();
    // intervalApiCall();
    setTimeout(() => {
      flightPathInterval();
    });
    myFlag = 0;
  } else myFlag = 1;

  useEffect(() => {
    if (typeof window.google !== "undefined" && window.google.maps) {
      // Proceed with your logic to use google.maps
      let driverDetails = props?.driverData?.filter(
        (el) => el.isOnTrip != "1" && el.isOnline
      );

      onlineDriversMarker.forEach((marker) => marker?.setMap(null));
      onlineDriversMarker = [];
      const infoWindow = new window.google.maps.InfoWindow();
      driverDetails.forEach((driver, i) => {
        if (driver.lastLL !== null) {
          onlineDriversMarker[i] = new window.google.maps.Marker({
            position: {
              lat: parseFloat(driver?.lastLL?.split(",")[0]),
              lng: parseFloat(driver?.lastLL?.split(",")[1]),
            },
            map,
            icon: {
              url: carIcon,
              scaledSize: new window.google.maps.Size(34, 34),
              anchor: new window.google.maps.Point(17, 17),
            },
            myTitle: `${driver.driverName} (${driver?.mobileNumber})`,
            Title: `${driver.driverName}`,
          });
          onlineDriversMarker[i]?.addListener("click", () => {
            infoWindow.close();
            infoWindow.setHeaderContent(onlineDriversMarker[i].myTitle);
            infoWindow.setContent(`On ${driver.lastUpdatedAt}`);
            infoWindow.open(
              onlineDriversMarker[i].getMap(),
              onlineDriversMarker[i]
            );
          });
        }
      });
      setIsLoadingRoute(false);
    } else {
      console.error("Google Maps API is not loaded yet.");
    }
  }, [props?.driverData, onTripDriverEmail]);

  function animateMarkerTo(
    marker,
    newLat,
    newLng,
    duration,
    onComplete = () => {}
  ) {
    const startPosition = marker.getPosition();
    const startLat = startPosition.lat();
    const startLng = startPosition.lng();

    const deltaLat = newLat - startLat;
    const deltaLng = newLng - startLng;

    const steps = 100;
    const stepDuration = duration / steps;
    let currentStep = 0;

    function step() {
      currentStep++;
      const progress = currentStep / steps;

      const intermediateLat = startLat + deltaLat * progress;
      const intermediateLng = startLng + deltaLng * progress;

      const newPosition = new window.google.maps.LatLng(
        intermediateLat,
        intermediateLng
      );
      marker.setPosition(newPosition);

      // 👇 Extend polyline during animation, for smooth drawing
      flightPlanCoordinates.push({
        lat: intermediateLat,
        lng: intermediateLng, 
      });

      if (currentStep < steps) {
        setTimeout(step, stepDuration);
      } else {
        marker.setPosition(new window.google.maps.LatLng(newLat, newLng));
        onComplete(); // Call the callback once done
      }
    }

    step();
  }

  // let lastAnimatedPosition = null; // Track the last position we animated to

  // function animateMarkerTo(
  //   marker,
  //   newLat,
  //   newLng,
  //   duration,
  //   onComplete = () => {}
  // ) {
  //   const currentPosition = marker.getPosition();

  //   // If we already have this position, skip animation
  //   if (
  //     lastAnimatedPosition &&
  //     lastAnimatedPosition.lat === newLat &&
  //     lastAnimatedPosition.lng === newLng
  //   ) {
  //     onComplete();
  //     return;
  //   }

  //   // If this is the first position or we're jumping to a new location
  //   if (
  //     !lastAnimatedPosition ||
  //     currentPosition.lat() !== lastAnimatedPosition.lat ||
  //     currentPosition.lng() !== lastAnimatedPosition.lng
  //   ) {
  //     // Immediate jump to new position without animation
  //     marker.setPosition(new window.google.maps.LatLng(newLat, newLng));
  //     flightPlanCoordinates.push({ lat: newLat, lng: newLng });
  //     lastAnimatedPosition = { lat: newLat, lng: newLng };
  //     onComplete();
  //     return;
  //   }

  //   // Only animate if this is a new position after the last animated one
  //   const startLat = currentPosition.lat();
  //   const startLng = currentPosition.lng();
  //   const deltaLat = newLat - startLat;
  //   const deltaLng = newLng - startLng;

  //   const steps = 100;
  //   const stepDuration = duration / steps;
  //   let currentStep = 0;

  //   function step() {
  //     currentStep++;
  //     const progress = currentStep / steps;

  //     const intermediateLat = startLat + deltaLat * progress;
  //     const intermediateLng = startLng + deltaLng * progress;

  //     const newPosition = new window.google.maps.LatLng(
  //       intermediateLat,
  //       intermediateLng
  //     );
  //     marker.setPosition(newPosition);

  //     // Extend polyline during animation
  //     flightPlanCoordinates.push({
  //       lat: intermediateLat,
  //       lng: intermediateLng,
  //     });

  //     if (currentStep < steps) {
  //       setTimeout(step, stepDuration);
  //     } else {
  //       marker.setPosition(new window.google.maps.LatLng(newLat, newLng));
  //       lastAnimatedPosition = { lat: newLat, lng: newLng };
  //       onComplete();
  //     }
  //   }

  //   step();
  // }

  const authenticateUser = (response) => {
    if (!tripIdOfOnTrip) {
      const lastLL = response?.DriverList?.LastLL;
      if (lastLL) {
        const [latStr, lngStr] = lastLL.split(",") || [];
        const lat = parseFloat(latStr) || 0;
        const lng = parseFloat(lngStr) || 0;
        if (lat && lng) {
          if (!marker) {
            marker = new window.google.maps.Marker({
              position: { lat, lng },
              map,
              icon: {
                url: carIcon,
                scaledSize: new window.google.maps.Size(40, 40),
              },
            });
          } else {
            animateMarkerTo(marker, lat, lng, 20000);
          }

          map.setCenter({ lat, lng });
          map.setZoom(15);
        }
      }
      return;
    }

    const data = response?.data;
    if (!onTripDriverEmail) return;

    const tripLocations = Array.isArray(data?.TripLocations)
      ? data?.TripLocations
      : [data?.TripLocations];

    if (tripLocations?.length > 0) {
      const latestLocation = tripLocations[tripLocations.length - 1];
      const lat = parseFloat(latestLocation?.LL?.split(",")?.[0]) || 0;
      const lng = parseFloat(latestLocation?.LL?.split(",")?.[1]) || 0;
      const bearing = latestLocation?.Bearing || 0;

      if (!driverFlag) {
        const lastCoord = flightPlanCoordinates.at(-1);

        if (!lastCoord || lastCoord.lat !== lat || lastCoord.lng !== lng) {
          const onAnimationComplete = () => {
            flightPlanCoordinates.push({ lat, lng });

            // Apply bearing rotation *after* smooth move
            const markerImg = document.querySelector(`[src="${carIcon}"]`);
            if (markerImg) markerImg.style.transform = `rotate(${bearing}deg)`;
          };

          if (!marker) {
            marker = new window.google.maps.Marker({
              position: { lat, lng },
              map,
              icon: {
                url: carIcon,
                scaledSize: new window.google.maps.Size(40, 40),
              },
            });

            // Don't push path until marker is fully placed
            onAnimationComplete();
          } else {
            // Move smoothly, then update path
            animateMarkerTo(marker, lat, lng, 20000, onAnimationComplete);
          }
        }
      } else {
        // First load of trip data
        flightPlanCoordinates = tripLocations.map((loc) => {
          const [latStr, lngStr] = loc?.LL?.split(",") || [0, 0];
          return {
            lat: parseFloat(latStr) || 0,
            lng: parseFloat(lngStr) || 0,
          };
        });

        driverFlag = false;
        drawLineFlag = true;

        const final = flightPlanCoordinates.at(-1);
        if (!marker) {
          marker = new window.google.maps.Marker({
            position: final,
            map,
            icon: {
              url: carIcon,
              scaledSize: new window.google.maps.Size(40, 40),
            },
          });
        } else {
          animateMarkerTo(marker, final.lat, final.lng, 20000);
        }

        const markerImg = document.querySelector(`[src="${carIcon}"]`);
        if (markerImg) markerImg.style.transform = `rotate(${bearing}deg)`;
      }

      journeyStart = 1;
      setIsTripEnded(false);
    } else if (data?.LivetripStatus?.toLowerCase() === "ended") {
      setIsTripEnded(true);
      flightPlanCoordinates = [];
      setRiderDetails([]); // Clear riders when trip ends

      if (marker) {
        marker.setMap(null);
        marker = null;
      }
    } else {
      setIsTripEnded(false);
    }

    const getTripStatusText = (statusNumber) => {
      return TripStatusText[statusNumber] || "UNKNOWN_STATUS";
    };

    const tripStatus = getTripStatusText(data?.data?.TripStatus)?.toLowerCase();
    if (!(tripStatus === "ended" || tripStatus === "arrived")) {
      if (startPointMarker) startPointMarker.setMap(null);
      if (endPointMarker) endPointMarker.setMap(null);

      let tripDetails = data?.data;
      // Try multiple possible paths for rider data (checking most common paths first)
      const newRiders = 
        tripDetails?.TripRiders || 
        data?.tripDetails?.TripRiders || 
        data?.TripRiders || 
        data?.data?.TripRiders ||
        [];

      // Update rider details
      if (Array.isArray(newRiders) && newRiders.length > 0) {
        setRiderDetails((prevRiders) => {
          // If previous riders list is empty, replace completely (new trip selected)
          // Otherwise, add unique riders (trip update)
          if (prevRiders.length === 0) {
            return newRiders;
          } else {
            // Combine existing riders with new ones, avoiding duplicates
            const uniqueRiders = newRiders.filter(
              (newRider) =>
                !prevRiders.some(
                  (existingRider) => 
                    existingRider.RiderID === newRider.RiderID ||
                    (existingRider.RiderName === newRider.RiderName && 
                     existingRider.MobileNumber === newRider.MobileNumber)
                )
            );
            return [...prevRiders, ...uniqueRiders];
          }
        });
      } else {
        // If no riders in response and we're on a trip, keep existing riders
        // Only clear if trip is ended or we explicitly want to clear
        // (This prevents clearing riders during trip updates when API doesn't return rider data)
      }

      const pickupLat =
        parseFloat(tripDetails?.ActualPickupLatLng?.split(",")?.[0]) ||
        parseFloat(tripDetails?.PickupLatLng?.split(",")?.[0]) ||
        0;
      const pickupLng =
        parseFloat(tripDetails?.ActualPickupLatLng?.split(",")?.[1]) ||
        parseFloat(tripDetails?.PickupLatLng?.split(",")?.[1]) ||
        0;

      if (pickupLat !== 0 || pickupLng !== 0) {
        startPointMarker = new window.google.maps.Marker({
          position: { lat: pickupLat, lng: pickupLng },
          map,
          icon: startPoint,
          myTitle:
            tripDetails?.ActualPickupName ||
            tripDetails?.PickupAddress ||
            "Pickup",
        });
      }

      const dropLat =
        parseFloat(tripDetails?.ActualDropOffLatLng?.split(",")?.[0]) ||
        parseFloat(tripDetails?.DropOffLatLng?.split(",")?.[0]) ||
        0;
      const dropLng =
        parseFloat(tripDetails?.ActualDropOffLatLng?.split(",")?.[1]) ||
        parseFloat(tripDetails?.DropOffLatLng?.split(",")?.[1]) ||
        0;

      endPointMarker = new window.google.maps.Marker({
        position: { lat: dropLat, lng: dropLng },
        map,
        icon: endPoint,
        myTitle: tripDetails?.DropOffAddress || "Dropoff",
      });

      const bounds = new window.google.maps.LatLngBounds();
      bounds.extend(new window.google.maps.LatLng(pickupLat, pickupLng));
      bounds.extend(new window.google.maps.LatLng(dropLat, dropLng));

      const infoWindow = new window.google.maps.InfoWindow();

      startPointMarker?.addListener("mouseover", () => {
        infoWindow.close();
        infoWindow.setHeaderContent(startPointMarker.myTitle);
        infoWindow.open(startPointMarker.getMap(), startPointMarker);
      });

      endPointMarker?.addListener("mouseover", () => {
        infoWindow.close();
        infoWindow.setHeaderContent(endPointMarker.myTitle);
        infoWindow.open(endPointMarker.getMap(), endPointMarker);
      });
    }
    setIsLoadingRoute(false);
  };

  const { isLoading, sendRequest } = useHttp();

  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/dashboard") {
      if (onTripDriverEmail && tripIdOfOnTrip) {
        intervalApiCall();
      }
    } else {
      clearInterval(trip_interval); // Clear the interval if not on the dashboard
    }

    // Cleanup when the component unmounts or the route changes
    return () => clearInterval(trip_interval);
  }, [onTripDriverEmail, tripIdOfOnTrip, location.pathname]);

  function intervalApiCall() {
    // Don't proceed if tripId is not set
    if (!tripIdOfOnTrip) return;
    
    flightPlanCoordinates = [];

    // Initial flag setup
    if (prev_driverEmail == null) {
      driverFlag = true;
    } else {
      driverFlag = prev_driverEmail !== onTripDriverEmail;
    }
    prev_driverEmail = onTripDriverEmail;

    // First call with all locations
    sendRequest(
      {
        url: "/trip",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: {
          emailID: localStorage.getItem("user"),
          data: { LocationCount: 9999, tripID: tripIdOfOnTrip },
        },
      },
      authenticateUser
    );

    // Set up interval for updates
    trip_interval = setInterval(() => {
      sendRequest(
        {
          url: "/trip",
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: {
            emailID: localStorage.getItem("user"),
            data: { tripID: tripIdOfOnTrip, LocationCount: 1 },
          },
        },
        authenticateUser
      );
    }, 20000);

    sessionStorage.setItem("interval", trip_interval);
  }

  function clearIntervalApiCall() {
    setRiderDetails([]);
    clearInterval(trip_interval);
    emailFlag = true;
  }

  function clearIntervalFligthPath() {
    marker?.setMap(null);
    clearInterval(pathInterval);
    // flightPath1?.setMap(null);
    flightPath2?.setMap(null);
  }

  // function flightPathInterval() {
  //   if (!onTripDriverEmail) {
  //     flightPlanCoordinates = [];
  //   }
  //   if (onTripDriverEmail == null) {
  //     flightPath2 = new window.google.maps.Polyline({
  //       path: flightPlanCoordinates,
  //     });
  //   } else {
  //     marker = new window.google.maps.Marker({
  //       position: flightPlanCoordinates[flightPlanCoordinates?.length - 1],
  //       map,
  //       icon: {
  //         url: carIcon,
  //         scaledSize: new window.google.maps.Size(34, 34),
  //         anchor: new window.google.maps.Point(17, 17),
  //       },
  //       optimized: false,
  //     });

  //     pathInterval = setInterval(() => {
  //       flightPath2 = new window.google.maps.Polyline({
  //         path: flightPlanCoordinates,
  //         // geodesic: true,
  //         strokeColor: "#00b0ff",
  //         strokeOpacity: 10.0,
  //         strokeWeight: 3,
  //       });

  //       if (document.getElementsByClassName("gm-fullscreen-control")[0])
  //         document.getElementsByClassName(
  //           "gm-fullscreen-control"
  //         )[0].style.marginTop = "45px";
  //       if (flightPlanCoordinates?.length > 1) {
  //         flightPath2?.setMap(null);
  //         flightPath2.setMap(map);
  //         marker.setPosition(
  //           flightPlanCoordinates[flightPlanCoordinates?.length - 1]
  //         );
  //       } else if (flightPlanCoordinates?.length > 0) {
  //         flightPath2?.setMap(null);
  //         flightPath2.setMap(map);
  //         marker.setPosition(
  //           flightPlanCoordinates[flightPlanCoordinates?.length - 1]
  //         );
  //       }
  //       if (
  //         (prev_driverEmail || prev_driverEmail == null) &&
  //         emailFlag &&
  //         flightPlanCoordinates[flightPlanCoordinates?.length - 1]?.lat
  //       ) {
  //         map.setCenter({
  //           lat: flightPlanCoordinates[flightPlanCoordinates?.length - 1]?.lat,
  //           lng: flightPlanCoordinates[flightPlanCoordinates?.length - 1]?.lng,
  //         });
  //         map.setZoom(14);
  //         emailFlag = false;
  //       } else if (
  //         !flightPlanCoordinates[flightPlanCoordinates?.length - 1]?.lat
  //       ) {
  //       }
  //       drawLineFlag = false;
  //     }, 2000);
  //     // },{LiveLocationCallDuration});
  //   }
  // }

  function flightPathInterval() {
    if (!onTripDriverEmail) {
      flightPlanCoordinates = [];
    }

    if (!onTripDriverEmail) {
      flightPath2 = new window.google.maps.Polyline({
        path: flightPlanCoordinates,
      });
    } else {
      marker = new window.google.maps.Marker({
        position: flightPlanCoordinates.at(-1),
        map,
        icon: {
          url: carIcon,
          scaledSize: new window.google.maps.Size(34, 34),
          anchor: new window.google.maps.Point(17, 17),
        },
        optimized: false,
      });

      pathInterval = setInterval(() => {
        if (flightPlanCoordinates.length === 0) return;

        if (flightPath2) flightPath2.setMap(null);

        flightPath2 = new window.google.maps.Polyline({
          path: flightPlanCoordinates,
          strokeColor: "#00b0ff",
          strokeOpacity: 1.0,
          strokeWeight: 3,
        });

        flightPath2.setMap(map);

        const latest = flightPlanCoordinates.at(-1);
        marker.setPosition(latest);

        if (
          (prev_driverEmail || prev_driverEmail == null) &&
          emailFlag &&
          latest?.lat
        ) {
          map.setCenter({ lat: latest.lat, lng: latest.lng });
          map.setZoom(14);
          emailFlag = false;
        }

        drawLineFlag = false;
      }, 2000);
    }
  }

  function myInitMap() {
    map = new window.google.maps.Map(document.getElementById("live-map"), {
      center: { lat: 23.0225, lng: 72.5714 },
      zoom: 12,
      disableDefaultUI: true,
      fullscreenControl: true,
      zoomControl: true,
    });
    flightPathInterval();
  }

  window.myInitMap = myInitMap;

  const driverSearchHandler = (e) => {
    setFilteredDriverData(
      props.driverData.filter(
        (data) =>
          data.driverName
            ?.toLowerCase()
            .includes(e.target.value.toLowerCase()) ||
          data.carNumber?.toLowerCase().includes(e.target.value.toLowerCase())
      )
    );
  };

  // Separate callback to extract only rider data without interfering with tracking
  const extractRiderDataOnly = (response) => {
    const data = response?.data;
    if (!data) return;

    let tripDetails = data?.data;
    // Try multiple possible paths for rider data (checking most common paths first)
    const newRiders = 
      tripDetails?.TripRiders || 
      data?.tripDetails?.TripRiders || 
      data?.TripRiders || 
      data?.data?.TripRiders ||
      [];

    // Update rider details immediately
    if (Array.isArray(newRiders) && newRiders.length > 0) {
      setRiderDetails(newRiders);
    } else {
      setRiderDetails([]);
    }
  };

  const onTripDriverClickHandler = (
    driverEmail,
    isOnTrip,
    driverName,
    tripId
  ) => {
    if (!tripIdOfOnTrip && !tripId) {
      sendRequest(
        {
          // url: "/api/v1/Trips/GetTripDetails",
          url: "/corporatedriver",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            data: {
              emailID: driverEmail,
            },
          },
        },
        authenticateUser
      );
    }
    if (isOnTrip == "1") {
      prev_driverId = driverEmail;
      onTripDriverName = driverName;
      // prev_driverEmail=driverEmail

      setRiderDetails([]); // Clear previous riders when selecting a new driver
      setIsExpanded(false); // Reset expanded state when switching drivers
      setOnTripDriverEmail(driverEmail);
      setIsLoadingRoute(true);
      setTrpID(tripId);
      
      // Immediately fetch rider data without interfering with tracking
      if (tripId) {
        sendRequest(
          {
            url: "/trip",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: {
              emailID: localStorage.getItem("user"),
              data: { LocationCount: 9999, tripID: tripId },
            },
          },
          extractRiderDataOnly // Use separate callback for rider data only
        );
      }
      // Note: intervalApiCall will be triggered by useEffect when onTripDriverEmail changes
      // It will handle car tracking and also extract rider data (which will be the same, so no conflict)
    }
  };

  const bookButtonClickHandler = (
    driverImage,
    driverName,
    carNumber,
    carType,
    driverType,
    driverEmail,
    carModel,
    carColor,
    shiftStartedInCorporateName,
    shiftStartedInCorporateID,
    tripId,
    shiftCarColor,
    shiftCarModel,
    shiftCarType,
    shiftCarNumber,
    // activeShiftCororateName,
    // activeShiftCorporateId
   
  ) => {
    setBookedDriver([
      {
        driverImage,
        driverName,
        carNumber,
        carType,
        driverType,
        driverEmail,
        carModel,
        carColor,
        shiftStartedInCorporateName,
        shiftStartedInCorporateID,
        tripId,
        shiftCarNumber,
        shiftCarType,
        shiftCarModel,
        shiftCarColor,
        // activeShiftCororateName,
        // activeShiftCorporateId,
        
      },
    ]);
  };

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const handleInfoClick = (event) => {
    setInfoAnchorEl(event.currentTarget);
  };
  const handleInfoClose = () => {
    setInfoAnchorEl(null);
  };
  const infoOpen = Boolean(infoAnchorEl);

  const handleSearchClick = () => {
    setIsSearchActive(true);
    setTimeout(() => {
      if (searchInputRef.current) {
        searchInputRef.current.focus();
      }
    }, 100);
  };

  const handleSearchChange = (e) => {
    const query = e.target.value.toLowerCase();

    setSearchQuery(e.target.value);

    setFilteredDriverData(
      props.driverData.filter(
        (data) =>
          (data.driverName && data.driverName.toLowerCase().includes(query)) ||
          (data.carNumber && data.carNumber.toLowerCase().includes(query)) ||
          (data.shiftCarNumber &&
            data.shiftCarNumber.toLowerCase().includes(query))
      )
    );
  };

  const clearSearch = () => {
    setSearchQuery("");
    setFilteredDriverData(props.driverData); // Reset filtered data to all drivers
    if (searchInputRef.current) {
      searchInputRef.current.focus();
      setIsSearchActive(false);
    }
  };

  const handleCopyClick = (event, shuttleId) => {
    event.stopPropagation(); // Ensure event propagation is stopped
    navigator.clipboard.writeText(shuttleId); // Verify clipboard write operation
    setCopiedItemId(shuttleId); // Check if copiedItemId is correctly set
    setTimeout(() => {
      setCopiedItemId(shuttleId); // Reset copiedItemId after timeout
    }, 1);
  };

  return (
    <React.Fragment>
      {bookedDriver && <div className="backdrop"></div>}
      <div
        className="main-container"
        id="privatedriver"
        style={props.toggle ? { padding: "15px 0px" } : {}}
      >
        <div
          className="driverlist"
          style={{
            pointerEvents: isLoadingRoute ? "none" : "auto",
            opacity: isLoadingRoute ? "0.7" : "1",
          }}
        >
          <div className="header">
            {/* <h4>Driver List</h4> */}
            {/* <p
              style={{
                fontFamily: "Poppins",
                fontSize: "16px",
                fontWeight: "300",
              }}
            >
              Driver List 
            </p> */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                height: "25px",
              }}
            >
              {!isSearchActive && (
                <>
                  <p
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "16px",
                      // fontWeight: "300",
                      fontWeight: "bold",
                      // margin: "0",
                    }}
                  >
                    Driver List
                  </p>
                  <div
                    onClick={handleSearchClick}
                    style={{ cursor: "pointer" }}
                  >
                    <CiSearch style={{ fontSize: "20px" }} />
                    {/* <FaSearch /> */}
                  </div>
                </>
              )}
              {isSearchActive && (
                <div style={{ display: "flex", gap: "42px" }}>
                  <div>
                    <TextField
                      type="text"
                      ref={searchInputRef}
                      value={searchQuery}
                      autoFocus
                      onChange={handleSearchChange}
                      placeholder="Search Drivers"
                      style={{ fontSize: "10px", width: "120%" }}
                      InputProps={{
                        startAdornment: (
                          <CiSearch
                            style={{
                              fontSize: "18px",
                              marginRight: "8px",
                              color: "#999",
                            }}
                          />
                        ),
                      }}
                      variant="standard"
                    />
                  </div>
                  <div
                    onClick={clearSearch}
                    style={{ cursor: "pointer", alignContent: "center" }}
                  >
                    <FaTimes style={{ color: "#D83434", fontSize: "16px" }} />
                  </div>
                </div>
              )}
            </div>

            <div className="driver-filter">
              <Tabs
                variant="fullWidth"
                sx={{
                  button: { padding: "0", fontSize: "12px" },
                  div: { minHeight: "35px" },
                  span: { bottom: "5px" },
                }}
                style={{ cursor: "pointer" }}
                centered
                value={servicesTabbarValue}
                onChange={(e, newValue) => {
                  if (newValue == "0") setFilteredDriverData(props.driverData);
                  else if (newValue == "2")
                    setFilteredDriverData(
                      props.driverData.filter((data) => data?.isOnTrip == "1")
                    );
                  else if (newValue == "1")
                    setFilteredDriverData(
                      props.driverData.filter(
                        (data) => data?.isOnline == "1" && data?.isOnTrip == "0"
                      )
                    );
                  setDriverFilterType(
                    newValue == "0"
                      ? "All"
                      : newValue == "1"
                      ? "Online"
                      : "On Trip"
                  );
                  setOnTripDriverEmail("");
                  setServicesTabbarValue(newValue);
                }}
                aria-label="basic tabs example"
              >
                <Tab
                  label="All"
                  style={{ fontWeight: "bold" }}
                  sx={{ button: { minHeight: "35px" } }}
                />
                <Tab
                  label="Online"
                  style={{ fontWeight: "bold" }}
                  sx={{ button: { minHeight: "35px" } }}
                />
                <Tab
                  label="On Trip"
                  style={{ fontWeight: "bold" }}
                  sx={{ button: { minHeight: "35px" } }}
                />
              </Tabs>
            </div>
          </div>
          <div className="driverDetails">
            {filteredDriverData?.length < 1 && !props.isLoading && (
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                No Drivers Available
              </div>
            )}
            {filteredDriverData?.map((ele) => {
              return (
                <div
                  id={ele.driverEmail}
                  key={ele.driverEmail}
                  className={`driverSingleData ${
                    ele.isOnTrip == "1" ? "driverContainer" : ""
                  } ${
                    onTripDriverEmail === ele.driverEmail ? "currentDriver" : ""
                  }`}
                  onClick={() => {
                    // Always set tripId on div click
                    setTripIdOfOnTrip(ele?.tripId);

                    // Handle on-trip driver click events
                    onTripDriverClickHandler(
                      ele?.driverEmail,
                      ele?.isOnTrip,
                      ele?.driverName,
                      ele?.tripId
                    );

                    // Trigger bookButtonClickHandler only if the driver is either on a trip or both online and shift started
                    if (
                      ele?.isOnTrip != "1" &&
                      ele?.isShiftStarted == "1" &&
                      ele?.isOnline == "1" &&
                      ele?.driverType.toLowerCase() == "private"
                    ) {
                      bookButtonClickHandler(
                        ele?.driverImage,
                        ele?.driverName,
                        ele?.carNumber,
                        ele?.vehicleType,
                        ele?.driverType,
                        ele?.driverEmail,
                        ele?.carModel,
                        ele?.carColor,
                        // ele?.activeShiftCororateName,
                        // ele?.activeShiftCorporateId,
                        ele?.shiftStartedInCorporateName,
                        ele?.shiftStartedInCorporateID,
                        ele?.tripId,
                        ele?.shiftCarColor,
                        ele?.shiftCarModel,
                        ele?.shiftCarType,
                        ele?.shiftCarNumber
                      );
                    }
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ position: "relative", alignSelf: "center" }}>
                      <img className="driverPhoto" src={ele.driverImage} />
                      <p
                        className={
                          ele?.isOnTrip == "1"
                            ? "ontrip"
                            : ele.isOnline == "1"
                            ? "online"
                            : "offline"
                          // : "offline"
                        }
                      ></p>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span className="drivername">{ele.driverName}</span>
                      <span className="carnumber">
                        {ele.shiftCarNumber
                          ? ele.shiftCarNumber.replaceAll("-", "")
                          : ele.carNumber.replaceAll("-", "")}
                      </span>
                      {(ele.isOnTrip == "1" ||
                        (ele.isOnline == "1" && ele.isShiftStarted == "1")) && (
                        <span
                          style={{
                            fontSize: "10px",
                            fontFamily: "Poppins",
                            textTransform: "capitalize",
                            color: "gray",
                          }}
                        >
                          {/* {ele.isOnTrip == "0" ? "private" : ele?.tripType} */}
                          {ele?.driverType}
                        </span>
                      )}
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      ></div>
                    </div>
                  </div>

                  {(ele?.isOnline && ele?.isOnTrip == "1") ||
                  (ele?.isOnline &&
                    ele?.driverType.toLowerCase() === "private" &&
                    ele?.isShiftStarted == "1") ? (
                    <button
                      className={
                        ele?.isOnline && ele?.isOnTrip == "1"
                          ? "onTripButtton"
                          : ele?.driverType.toLowerCase() === "private"
                          ? "bookButton"
                          : null
                      }
                    >
                      {ele?.isOnline && ele?.isOnTrip == "1"
                        ? "On Trip"
                        : ele?.driverType.toLowerCase() === "private"
                        ? "Book"
                        : ""}
                    </button>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
        <div className="privateDriverMap-container">
          <div className="mapText">
            <span
              style={{
                fontFamily: "Poppins",
                fontSize: "16px",
                fontWeight: "300",
              }}
            >
              Live Trip Tracker
            </span>
          </div>
          <div className="livetrip" id="live-map"></div>

          {onTripDriverEmail && (
            <div
              className="riderInfoContainer"
              style={{
                border: "1px solid #ccc",
                padding: "0px 8px",
                borderRadius: "8px",
                width: "auto",
                height: "auto",
                opacity: "0.9",
              }}
            >
              {/* Trip ID Section */}
              {trpID && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Tooltip
                      title={copiedItemId === trpID ? "Copied!" : "Copy Route ID"}
                      arrow
                    >
                      <IconButton
                        style={{ marginLeft: "-5%" }}
                        onClick={(event) => handleCopyClick(event, trpID)}
                      >
                        <FileCopyIcon style={{ width: "14px" }} />
                      </IconButton>
                    </Tooltip>
                    <div>
                      <div style={{ fontSize: "12px", wordBreak: "break-all" }}>
                        {trpID}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Riders Section */}
              {riderDetails?.length > 0 ? (
                <>
                  {/* Show only first rider in main list */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    {riderDetails.length > 0 && (
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        <FaRegUserCircle />
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: "500" }}>
                            {riderDetails[0]?.RiderName || "N/A"}
                          </div>
                          <div style={{ fontSize: "11px", color: "#666" }}>
                            {riderDetails[0]?.MobileNumber || "N/A"}
                          </div>
                          <div
                            style={{
                              fontSize: "10px",
                              color: "#1976d2",
                              marginTop: "4px",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <span>
                              <span style={{ fontWeight: "500" }}>IN: </span>
                              <span>
                                {riderDetails[0]?.ActualPickupTime
                                  ? new Date(
                                      riderDetails[0].ActualPickupTime
                                    ).toLocaleString("en-US", {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: true,
                                    })
                                  : "--"}
                              </span>
                            </span>
                            <span>
                              <span style={{ fontWeight: "500" }}>OUT: </span>
                              <span>
                                {riderDetails[0]?.ActualDropTime
                                  ? new Date(
                                      riderDetails[0].ActualDropTime
                                    ).toLocaleString("en-US", {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: true,
                                    })
                                  : "--"}
                              </span>
                            </span>
                          </div>
                        </div>
                        {/* Info icon for multiple riders */}
                        {riderDetails.length > 1 && (
                          <>
                            <IconButton
                              size="small"
                              onClick={handleInfoClick}
                              onMouseEnter={handleInfoClick}
                              style={{
                                padding: "4px",
                                color: "#1976d2",
                                cursor: "pointer",
                              }}
                              aria-label="Show all riders"
                            >
                              <InfoIcon style={{ fontSize: "16px" }} />
                            </IconButton>
                            <Popover
                              open={infoOpen}
                              anchorEl={infoAnchorEl}
                              onClose={handleInfoClose}
                              onMouseLeave={handleInfoClose}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                              }}
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "left",
                              }}
                              PaperProps={{
                                style: {
                                  padding: "6px",
                                  maxWidth: "280px",
                                  maxHeight: "300px",
                                  overflowY: "auto",
                                },
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "4px",
                                }}
                              >
                                <div
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "12px",
                                    marginBottom: "2px",
                                    color: "#1976d2",
                                  }}
                                >
                                  All Riders ({riderDetails.length})
                                </div>
                                {riderDetails.map((r, idx) => (
                                  <div
                                    key={idx}
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      alignItems: "flex-start",
                                      padding: "3px 0",
                                      borderBottom:
                                        idx < riderDetails.length - 1
                                          ? "1px solid #eee"
                                          : "none",
                                    }}
                                  >
                                    <div
                                      style={{
                                        minWidth: "18px",
                                        height: "18px",
                                        borderRadius: "50%",
                                        backgroundColor: "#1976d2",
                                        color: "white",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "9px",
                                        fontWeight: "bold",
                                        flexShrink: 0,
                                      }}
                                    >
                                      {idx + 1}
                                    </div>
                                    <div style={{ flex: 1 }}>
                                      <div
                                        style={{
                                          fontWeight: "500",
                                          fontSize: "11px",
                                          marginBottom: "1px",
                                          lineHeight: "1.3",
                                        }}
                                      >
                                        {r.RiderName || "N/A"}
                                      </div>
                                      <div
                                        style={{
                                          fontSize: "9px",
                                          color: "#666",
                                          marginBottom: "1px",
                                          lineHeight: "1.3",
                                        }}
                                      >
                                        {r.MobileNumber || "N/A"}
                                      </div>
                                      <div
                                        style={{
                                          fontSize: "8px",
                                          color: "#666",
                                          marginTop: "2px",
                                          padding: "2px 5px",
                                          backgroundColor: "#e3f2fd",
                                          borderRadius: "3px",
                                          display: "inline-block",
                                          lineHeight: "1.3",
                                        }}
                                      >
                                        <span style={{ fontWeight: "500" }}>
                                          IN:{" "}
                                        </span>
                                        <span>
                                          {r.ActualPickupTime
                                            ? new Date(
                                                r.ActualPickupTime
                                              ).toLocaleString("en-US", {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                              })
                                            : "--"}
                                        </span>
                                        <span style={{ marginLeft: "6px" }}>
                                          <span style={{ fontWeight: "500" }}>
                                            OUT:{" "}
                                          </span>
                                          <span>
                                            {r.ActualDropTime
                                              ? new Date(
                                                  r.ActualDropTime
                                                ).toLocaleString("en-US", {
                                                  hour: "2-digit",
                                                  minute: "2-digit",
                                                  hour12: true,
                                                })
                                              : "--"}
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </Popover>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    padding: "8px 0",
                    color: "#666",
                    fontSize: "14px",
                  }}
                >
                  <FaRegUserCircle />
                  <div>No riders assigned to this trip</div>
                </div>
              )}
            </div>
          )}

          {isLoadingRoute && (
            <div
              style={{
                position: "absolute",
                top: "40px",
                left: "0",
                width: "100%",
                height: "calc(100% - 40px)",
                backgroundColor: "white",
                opacity: "0.5",
              }}
            ></div>
          )}
          {isLoadingRoute && <Loading driver="true" />}
        </div>
      </div>
      {bookedDriver && (
        <DriverBooking
          bookedDriver={bookedDriver}
          setBookedDriver={setBookedDriver}
          riderData={props.riderData}
          tripRequestStatusFunc={(status) => {
            setTripRequestStatus(status);
            setBookedDriver(false);
          }}
        />
      )}
      {isTripEnded && (
        <Message
          type="success"
          message={onTripDriverName + "'s Trip has been ended"}
        />
      )}
    </React.Fragment>
  );
};

export default LiveTracking;
